import { API_URLS } from '../constants/api_urls';
import api from '../utils/API';

export const calculateTotalAUM = async (accountIds, token) => {
  const portfolioList = async (id) => {
    try {
      const response = await api.get(`${API_URLS.ACCOUNTS_V3}/${id}/portfolio`, {
        params: { limit: -1, offset: 0 },
        headers: { Authorization: `Bearer ${token}` },
      });
      return response?.data?.list || [];
    } catch (error) {
      console.error('Portfolio fetch error:', error);
      return [];
    }
  };

  const results = await Promise.allSettled(
    accountIds.map(async (accountId) => {
      const portfolios = await portfolioList(accountId);
      return portfolios.reduce(
        (sum, portfolio) =>
          sum + (portfolio.is_sync_active ? portfolio?.total_value ?? 0 : 0),
        0
      );
    })
  );

  return results.reduce((total, result) => total + (result.status === 'fulfilled' ? result.value : 0), 0);
};